import React, { useEffect, useState } from 'react';
import {
  PageContent,
  CompactTable,
  useFetch,
  User,
  Group,
  useUserinfo,
} from '@mss/mss-component-library';
import Button from '../../../../../common/Button';
import { useParams, useHistory } from 'react-router-dom';
import columns from './columns';
import AddGroupModal from './AddGroupModal';
import Api from '../../../../services/Api';
import { useTranslation } from 'react-i18next';

type GroupsProps = {
  user: User;
  fetchUser: () => void;
};
type UserGroup = {
  id: number;
  user: string;
  group: number;
};

function Groups({ user, fetchUser }: GroupsProps) {
  const [hasPermission] = useUserinfo();
  const { userId } = useParams<{ userId: string }>();
  const [t] = useTranslation(['authorization', 'common']);
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [mergedGroups, setMergedGroups] = useState<any[]>([]);
  const [groupInfo, fetchGroupInfo] = useFetch({
    url: `/api/user/group/?user=${userId}&group=`,
    initialFetch: hasPermission([
      'add_usergroup',
      'delete_usergroup',
      'view_group',
    ]),
    defaultValue: [],
    onEmpty: () => {
      setMergedGroups([]);
    },
    onSucces: async ({ data: userGroups }) => {
      const resp = await Api.group.all();
      const allGroups = await resp.json();
      setMergedGroups(
        allGroups
          .map((group: Group) => ({
            ...group,
            relationId: userGroups.find(
              (userGroup: UserGroup) => userGroup.group === group.id
            )?.id,
          }))
          .filter(
            (x: Group) => !!userGroups.find((y: UserGroup) => y.group === x.id)
          )
      );
    },
  });

  useEffect(() => {
    fetchUser();
  }, [mergedGroups]);

  return (
    <PageContent
      title={t('Groups')}
      actions={
        hasPermission('change_user') &&
        hasPermission('add_usergroup') && (
          <Button
            variant="primary"
            onClick={() => setShowModal(true)}
            data-ta="newGroupButton"
          >
            {t('ADD GROUP')}
          </Button>
        )
      }
    >
      <CompactTable
        dataSource={mergedGroups}
        loading={groupInfo.loading}
        columns={columns(t, fetchGroupInfo)}
        rowKey="id"
        onRow={(record: any) => ({
          onClick: () => history.push(`/authorization/groups/${record.id}/`),
        })}
        pagination={false}
        showHeader={false}
        bordered={false}
      />
      {showModal && (
        <AddGroupModal
          user={user}
          fetchGroupInfo={fetchGroupInfo}
          closeModal={() => setShowModal(false)}
        />
      )}
    </PageContent>
  );
}

export default Groups;
